import * as yup from 'yup';

export const associateOrderTagScheme = yup.object({
  orderId: yup.string().required().uuid(),
  tagId: yup.string().required(),
  value: yup.string().optional().max(64, 'Value may not exceed 64 characters'),
});
